import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import FoodForm from '../../../../Componant/Application/Project/master/FoodForm'


const FoodContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <FoodForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default FoodContainer